import React from "react";

import { getAutomationDataAttr } from "../../../utils/automationUtils";
import { testLocator } from "@/lib/helpers/test-locator";

import "./styles.scss";

const InputError = (props) => {
  let classes = "InputError ";

  if (props.classes) {
    classes += props.classes;
  }

  return (
    <span className={classes} style={props.style} {...getAutomationDataAttr(props.testId)} {...testLocator(props.testId)}>
      {props.children}
    </span>
  );
};

export default InputError;
